<template>
	<button
		type="button"
		class="flex flex-col items-start w-full px-3 py-3.5 text-left rounded-lg bg-grey-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-900"
		:aria-expanded="isOpen ? 'true' : 'false'"
		data-testid="profile-insight-toggle"
		@click="open = !open"
	>
		<span class="flex items-center justify-between w-full gap-6">
			<span class="flex items-center min-w-0 gap-4">
				<span class="flex items-center justify-center text-grey-300 shrink-0">
					<slot />
				</span>

				<span class="font-medium text-white">
					{{ heading }}
				</span>
			</span>

			<Component
				:is="isOpen ? 'IconMinus' : 'IconPlus'"
				size="16"
				class="text-grey-400 shrink-0"
			/>
		</span>

		<span
			v-if="isOpen"
			class="block pl-9 mt-2 text-sm text-grey-300"
			data-testid="profile-insight-content"
		>
			{{ body }}
		</span>
	</button>
</template>

<script>
import { IconMinus, IconPlus } from '~/components/Icons'

export default {
	name: 'ProfileInsight',
	components: {
		IconMinus,
		IconPlus
	},
	inject: {
		personalityResultsExport: { default: null }
	},
	props: {
		heading: {
			type: String,
			required: true
		},
		body: {
			type: String,
			required: false,
			default: ''
		}
	},
	data() {
		return {
			open: false
		}
	},
	computed: {
		isOpen() {
			return (
				this.open ||
				Boolean(this.personalityResultsExport?.exporting)
			)
		}
	}
}
</script>
